import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { LoadingSpinner } from '../Components/Molecules/LoadingUI';

import PrivateRoute from '../Components/Molecules/PrivateRoute';
import ConditionalRoute from '../Components/Molecules/ConditionalRoute';
// import PointSystemLedger from './PointSystemLedger';
// Lazy load all route components
const EmpanelmentForm = React.lazy(() => import('./EmpanelmentForm'));
const Home = React.lazy(() => import('./Home'));
const Login = React.lazy(() => import('../Components/Login'));
const UserProfile = React.lazy(
    () => import('./MyProfile/UserProfile/newIndex')
);
const WinnreDealsAndDiscounts = React.lazy(() => import('./DealsAndDiscounts'));
const PointSystemLedger = React.lazy(() => import('./PointSystemLedger'));
const MyOrders = React.lazy(() => import('./MyOrders'));
const WinnreDealDetails = React.lazy(() => import('./DealDetails'));
const WinnreProductListing = React.lazy(() => import('./ProductListing'));
const WinnreBundleDeals = React.lazy(() => import('./BundleDeals'));
const WinnreBundleDetails = React.lazy(() => import('./BundleDetails'));
const SignupComponent = React.lazy(() => import('../Components/Signup'));
const Documentation = React.lazy(() => import('./Documentation'));
const Enquiries = React.lazy(() => import('./Enquiries'));
const InvoiceList = React.lazy(() => import('./Finance/Invoice'));
const BookingListComponent = React.lazy(() => import('./Finance/Bookings'));
const InvoicePreivew = React.lazy(() => import('./Finance/invoicepreview'));
const Leads = React.lazy(() => import('./Customers/Leads'));
const Customers = React.lazy(() => import('./Customers/Customers'));
const WinnreProjects = React.lazy(() => import('./Projects'));
const WinnreProjectDetail = React.lazy(() => import('./Projects/Detail'));
const WinnreEvents = React.lazy(() => import('./Events'));
const WinnreEventDetail = React.lazy(() => import('./Events/Detail'));
const SurveyPage = React.lazy(() => import('./Survey'));
const RequestList = React.lazy(
    () => import('./RequestTicket/Components/RequestList')
);
const RequestForm = React.lazy(
    () => import('./RequestTicket/Components/RequestForm')
);
const DocumentPreview = React.lazy(
    () => import('./Documentation/Components/DigitalSign')
);
const TeamMemberList = React.lazy(() => import('./Teammember/TeammemberList'));
const AboutUs = React.lazy(() => import('./AboutUs'));
const CheckoutComponent = React.lazy(() => import('./Checkout'));
const OrderStatusComponent = React.lazy(() => import('./OrderStatus'));

const PageNotFound = React.lazy(() => import('./404'));
const MyProfile = React.lazy(() => import('./MyProfile'));
const TermsAndConditions = React.lazy(() => import('./TermsAndConditions'));
const ContactUs = React.lazy(() => import('./ContactUs'));

function Routes({ routesConfig }) {
    // console.log('routes');
    return (
        <Suspense
            fallback={
                <div className=" h-screen">
                    <LoadingSpinner />
                </div>
            }
        >
            <main className="">
                <Switch>
                    <Route path="/" exact>
                        <Home config={routesConfig} />
                    </Route>
                    {/* <Route path='/login' exact>
                       <Login/>
                    </Route> */}
                    <Route path="/sign-up">
                        <SignupComponent />
                    </Route>

                    <Route path="/empanelment-form">
                        <EmpanelmentForm />
                    </Route>
                    <Route path="/myprofile/docs">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <Documentation />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myProfile/info">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <UserProfile />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myProfile/info">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <UserProfile />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myProfile/team-member-list">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <TeamMemberList />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myprofile/support-tickets" exact>
                        <PrivateRoute roleRequired={['CHANNEL_PARTNER']}>
                            <MyProfile>
                                <RequestForm />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myprofile/support-tickets/list" exact>
                        <PrivateRoute roleRequired={['CHANNEL_PARTNER']}>
                            <MyProfile>
                                <RequestList />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>

                    <Route path="/myProfile/leads">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <Leads />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myProfile/customers">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <Customers />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/projects" exact>

                        <WinnreProjects />

                    </Route>
                    <Route path="/contact-us" exact>

                        <ContactUs />

                    </Route>
                    <Route path="/projects/detail" exact>

                        <WinnreProjectDetail />

                    </Route>
                    <Route path="/events" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <WinnreEvents />
                        </PrivateRoute>
                    </Route>
                    <Route path="/events/:eventId" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <WinnreEventDetail />
                        </PrivateRoute>
                    </Route>
                    <Route path="/deals" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <WinnreDealsAndDiscounts />
                        </PrivateRoute>
                    </Route>
                    <Route path="/dealListing" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreProductListing
                                isRewards={false}
                                isCustom={false}
                            />
                        </PrivateRoute>
                    </Route>
                    <Route path="/deals/:dealId" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreDealDetails />
                        </PrivateRoute>
                    </Route>
                    {/* Bundle deals listing route */}
                    <Route path="/bundle-deals" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreBundleDeals />
                        </PrivateRoute>
                    </Route>
                    {/* Curated deals listing route */}
                    <Route path="/curatedDeals" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreProductListing
                                isRewards={false}
                                isCustom={true}
                            />
                        </PrivateRoute>
                    </Route>
                    <Route path="/rewardpointstore" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <WinnreDealsAndDiscounts isRewards={true} />
                        </PrivateRoute>
                    </Route>
                    <Route path="/myprofile/rewardPoints" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            {' '}
                            <MyProfile>
                                <PointSystemLedger isRewards={true} />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myprofile/coinStore/orders" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            {' '}
                            <MyProfile>
                                <MyOrders isPoints={true} />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    {/* Checkout route for rewards */}
                    <Route path="/checkout" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <CheckoutComponent config={routesConfig} />
                        </PrivateRoute>
                    </Route>
                    {/* Order Status route */}
                    <Route path="/orderstatus/:orderId" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <OrderStatusComponent config={routesConfig} />
                        </PrivateRoute>
                    </Route>
                    {/* Reward Store Deal Details route */}
                    <Route path="/rewardPointStore/:dealId" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreDealDetails isRewards={true} />
                        </PrivateRoute>
                    </Route>
                    {/* Reward Deal Listing route */}
                    <Route path="/reward-dealListing" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreProductListing
                                isRewards={true}
                                isCustom={false}
                            />
                        </PrivateRoute>
                    </Route>
                    {/* Curated deals detail route */}
                    <Route path="/curated/:dealId" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreDealDetails />
                        </PrivateRoute>
                    </Route>
                    {/* Bundle details route */}
                    <Route path="/bundleDetails" exact>
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                            authNotRequired
                        >
                            <WinnreBundleDetails />
                        </PrivateRoute>
                    </Route>
                    {/* Category redirects for parity with Connectre */}
                    <Route path="/moveInOffers">
                        <Redirect to="dealListing?categoryID=2&categoryName=Exclusive%20Move%20In%20Offers" />
                    </Route>
                    <Route path="/lifestyleOffers">
                        <Redirect to="dealListing?categoryID=1&categoryName=Member%20Benefits" />
                    </Route>
                    <Route path="/financeOffers">
                        <Redirect to="dealListing?categoryID=3&categoryName=Home%20Financing%20Deals" />
                    </Route>
                    <Route path="/externalOffers">
                        <Redirect to="dealListing?categoryID=9&categoryName=External%20Offers" />
                    </Route>
                    <Route path="/digitalAmenities">
                        <Redirect to="/dealListing?categoryID=5&categoryName=Digital%20Amenities" />
                    </Route>
                    <Route path="/myProfile/enquiries">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <Enquiries />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myProfile/invoice">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <InvoiceList />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/myProfile/booking">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <BookingListComponent />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>

                    <Route path="/myProfile/invoicepreview">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <InvoicePreivew />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    {/* About Us - visible to all (no role gating) */}
                    <Route path="/myProfile/about-us" exact>
                        <MyProfile>
                            <AboutUs />
                        </MyProfile>
                    </Route>
                    {/* Also support lowercase path for sidebar links */}
                    <Route path="/myprofile/about-us" exact>
                        <MyProfile>
                            <AboutUs />
                        </MyProfile>
                    </Route>
                    <Route path="/myProfile/documentpreview/:id">
                        <PrivateRoute
                            roleRequired={['CHANNEL_PARTNER', 'LEAD_CP']}
                        >
                            <MyProfile>
                                <DocumentPreview />
                            </MyProfile>
                        </PrivateRoute>
                    </Route>
                    <Route path="/terms-and-conditions">
                        <TermsAndConditions />
                    </Route>

                    <Route path="/surveyform/:id">
                        <SurveyPage />
                    </Route>
                    <Route path="*">
                        <PageNotFound />
                    </Route>
                </Switch>
            </main>
        </Suspense>
    );
}

export default Routes;
